module.exports = __webpack_public_path__ + "static/media/estilo6.5b57f8ec.png";